import Screen from "./components/Screen"
import Button from "./components/Button"
import { spacing } from "./styles"

import "./WebHosting.scss"
import { useNavigate } from "react-router-dom"
import Flex from "../../components/Flex"
import Icons from "../../components/Icons"
import datasource from "../../datasource"

interface Capability {
    title: string
    description: string
}

interface Partner {
    slug: string
    name: string
    practice: string
    tagline: string
    url: string
    icon: React.JSX.Element
}

const {
    pageTitle,
    pageSubTitle,
    heroCtaLabel,
    pitch,
    highlight,
    capabilities,
    partners,
    welcomeTitle,
    welcomeSubTitle,
    welcomeBtnLabel
} = datasource.webhosting

export default () => {

    const navigate = useNavigate()

    const goToContactUs = () => {
        navigate("/")
        setTimeout(() => {
            document.scrollingElement?.scrollTo({ top: window.innerHeight, behavior: "smooth" })
        }, 100)
    }

    return (
        <div className="webhosting">
            <Screen className="webhosting__title-screen">
                <Flex vertical align="center" gap={spacing("4xl")}>
                    <Flex align="center" justify="center" className="webhosting__hero-icon">
                        <Icons.WebHosting width={74} height={74}></Icons.WebHosting>
                    </Flex>
                    <div className="webhosting__title">{pageTitle}</div>
                    <div className="webhosting__subTitle">{pageSubTitle}</div>
                    <Button onClick={goToContactUs}>
                        <Flex gap={spacing("md")} reposive={false} align="center">
                            {heroCtaLabel}
                            <Icons.ArrowUp width={16} height={16}></Icons.ArrowUp>
                        </Flex>
                    </Button>
                </Flex>
            </Screen>

            <Screen className="webhosting__pitch-screen">
                <div className="webhosting__panel">
                    <Flex vertical gap={spacing("3xl")}>
                        <div className="webhosting__section-title">{pitch.title}</div>
                        {pitch.paragraphs.map((paragraph, i) => (
                            <div key={i} className="webhosting__pitch__text">{paragraph}</div>
                        ))}
                    </Flex>
                </div>
            </Screen>

            <Screen className="webhosting__highlight-screen">
                <div className="webhosting__highlight">
                    <Flex justify="space-between" gap={spacing("6xl")}>
                        <Flex vertical gap={spacing("xl")} className="webhosting__highlight__left">
                            <div className="webhosting__highlight__eyebrow">{highlight.eyebrow}</div>
                            <div className="webhosting__highlight__title">{highlight.title}</div>
                            <div className="webhosting__highlight__description">{highlight.description}</div>
                            <Flex vertical gap={spacing("md")} className="webhosting__highlight__examples">
                                {highlight.examples.map(example => (
                                    <div key={example} className="webhosting__highlight__example">&ldquo;{example}&rdquo;</div>
                                ))}
                            </Flex>
                        </Flex>
                        <Flex vertical gap={spacing("xl")} justify="center" className="webhosting__highlight__right">
                            {highlight.points.map(point => (
                                <div key={point} className="webhosting__highlight__point">{point}</div>
                            ))}
                        </Flex>
                    </Flex>
                </div>
            </Screen>

            <Screen className="webhosting__capabilities-screen">
                <Flex vertical align="center" gap={spacing("xl")} className="webhosting__section-head">
                    <div className="webhosting__section-title">{capabilities.title}</div>
                    <div className="webhosting__section-subTitle">{capabilities.subTitle}</div>
                </Flex>
                <div className="webhosting__capabilities">
                    {(capabilities.items as Capability[]).map(capability => (
                        <Flex vertical gap={spacing("md")} key={capability.title} className="capability-card">
                            <div className="capability-card__title">{capability.title}</div>
                            <div className="capability-card__description">{capability.description}</div>
                        </Flex>
                    ))}
                </div>
            </Screen>

            <Screen className="webhosting__partners-screen">
                <div className="webhosting__panel">
                    <Flex vertical align="center" gap={spacing("xl")} className="webhosting__section-head">
                        <div className="webhosting__section-title">{partners.title}</div>
                        <div className="webhosting__section-subTitle">{partners.subTitle}</div>
                    </Flex>
                    <div className="webhosting__partners">
                        {(partners.items as Partner[]).map(partner => (
                            <a
                                key={partner.slug}
                                className="partner-card"
                                href={partner.url}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <Flex vertical align="center" gap={spacing("xl")}>
                                    <Flex align="center" justify="center" className="partner-card__logo">
                                        {partner.icon}
                                    </Flex>
                                    <Flex vertical align="center" gap={spacing("xs")}>
                                        <div className="partner-card__name">{partner.name}</div>
                                        <div className="partner-card__practice">{partner.practice}</div>
                                    </Flex>
                                    {partner.tagline ? <div className="partner-card__tagline">{partner.tagline}</div> : null}
                                    <Flex align="center" gap={spacing("md")} reposive={false} className="partner-card__link">
                                        {partners.linkLabel}
                                        <Icons.ArrowUp width={14} height={14}></Icons.ArrowUp>
                                    </Flex>
                                </Flex>
                            </a>
                        ))}
                    </div>
                </div>
            </Screen>

            <div className="webhosting__welcome-box">
                <Flex className="webhosting__welcome" justify="space-between">
                    <Flex vertical gap={10}>
                        <div className="webhosting__welcome__title">{welcomeTitle}</div>
                        <div className="webhosting__welcome__subTitle">{welcomeSubTitle}</div>
                    </Flex>
                    <Flex vertical justify="flex-end">
                        <Button onClick={goToContactUs}>
                            <Flex gap={spacing("md")} reposive={false} align="center">
                                {welcomeBtnLabel}
                                <Icons.ArrowUp width={16} height={16}></Icons.ArrowUp>
                            </Flex>
                        </Button>
                    </Flex>
                </Flex>
            </div>
        </div>
    )
}
